'use strict';

var PRIME = angular.module("PRIME", [
	"ngRoute",
	"ngAnimate",
	"ui.bootstrap",
	"ui.bootstrap.popover",
	"PRIMEControllers",
	"PRIMEControllersT2D",
	"PRIMEControllersUKPDSOM2",
	"PRIMEDirectives",
	"PRIMEServices",
	"PRIMEServicesT2D",
	"PRIMEServicesUKPDSOM2",
	"AdminControllers",
	"chart.js",
	"multipleSelect"
]);

PRIME.config(function(ChartJsProvider) {
	ChartJsProvider.setOptions({ chartColors : [ '#999999', '#F74902', '#DCDCDC', '#46BFBD', '#FDB45C', '#949FB1', '#4D5360'] });
})

PRIME.config(["$routeProvider", "$locationProvider", "$httpProvider",
	function($routeProvider, $locationProvider, $httpProvider) {
		
		$httpProvider.interceptors.push("responseObserver");
		
		$routeProvider.
			when("/home", {
				controller: "Home",
				templateUrl: "partials/home.html"
			}).
			when("/cohorts", {
				controller: "Cohorts",
				templateUrl: "partials/cohorts.html"
			}).
			when("/cohort/:id", {
				controller: "EditCohort",
				templateUrl: "partials/cohort-new.html?v=1.5.3"
			}).
			when("/treatments", {
				controller: "Treatments",
				templateUrl: "partials/treatments.html"
			}).
			when("/treatment/:id", {
				controller: "EditTreatment",
				templateUrl: "partials/treatment-new.html?v=1.5.3"
			}).
			when("/costs", {
				controller: "Costs",
				templateUrl: "partials/costs.html"
			}).
			when("/cost/:id", {
				controller: "EditCost",
				templateUrl: "partials/cost-new.html"
			}).
			when("/utilities", {
				controller: "Utilities",
				templateUrl: "partials/utilities.html"
			}).
			when("/utility/:id", {
				controller: "EditUtility",
				templateUrl: "partials/utility-new.html"
			}).
			when("/countries", {
				controller: "Countries",
				templateUrl: "partials/countries.html"
			}).
			when("/country/:id", {
				controller: "EditCountry",
				templateUrl: "partials/country-new.html?v=1.5.2"
			}).
			when("/simulations", {
				controller: "Simulations",
				templateUrl: "partials/simulations.html?v=1.5.3"
			}).
			when("/simulation/:id", {
				controller: "Simulation",
				templateUrl: "partials/simulation.html?v=1.5.3"
			}).
			when("/simulations/new", {
				controller: "NewSimulation",
				templateUrl: "partials/simulation-new.html?v=1.0.9"
			}).
			when("/simulations/new/:id", {
				controller: "NewSimulation",
				templateUrl: "partials/simulation-new.html?v=1.0.9"
			}).
			when("/t2d/home", {
				controller: "HomeT2D",
				templateUrl: "partials/t2d/home.html"
			}).
			when("/t2d/cohorts", {
				controller: "CohortsT2D",
				templateUrl: "partials/t2d/cohorts.html?v=1.2.1"
			}).
			when("/t2d/cohort/:id", {
				controller: "EditCohortT2D",
				templateUrl: "partials/t2d/cohort-new.html?v=1.5.5"
			}).
			when("/t2d/treatments", {
				controller: "TreatmentsT2D",
				templateUrl: "partials/t2d/treatments.html?v=1.2.1"
			}).
			when("/t2d/treatment/:id", {
				controller: "EditTreatmentT2D",
				templateUrl: "partials/t2d/treatment-new.html?v=1.3.7"
			}).
			when("/t2d/costs", {
				controller: "CostsT2D",
				templateUrl: "partials/t2d/costs.html?v=1.2.1"
			}).
			when("/t2d/cost/:id", {
				controller: "EditCostT2D",
				templateUrl: "partials/t2d/cost-new.html?v=1.5.5"
			}).
			when("/t2d/utilities", {
				controller: "UtilitiesT2D",
				templateUrl: "partials/t2d/utilities.html?v=1.2.1"
			}).
			when("/t2d/utility/:id", {
				controller: "EditUtilityT2D",
				templateUrl: "partials/t2d/utility-new.html?v=1.5.5"
			}).
			when("/t2d/countries", {
				controller: "CountriesT2D",
				templateUrl: "partials/t2d/countries.html?v=1.2.1"
			}).
			when("/t2d/country/:id", {
				controller: "EditCountryT2D",
				templateUrl: "partials/t2d/country-new.html"
			}).
			when("/t2d/sensitivity-analyses", {
				controller: "SensitivityAnalysesT2D",
				templateUrl: "partials/t2d/owsas.html"
			}).
			when("/t2d/simulations", {
				controller: "SimulationsT2D",
				templateUrl: "partials/t2d/simulations.html?v=1.2.6"
			}).
			when("/t2d/simulation/:id", {
				controller: "SimulationT2D",
				templateUrl: "partials/t2d/simulation.html?v=1.5.5.1"
			}).
			when("/t2d/simulations/new", {
				controller: "NewSimulationT2D",
				templateUrl: "partials/t2d/simulation-new.html?v=1.5.3"
			}).
			when("/t2d/simulations/new/:id", {
				controller: "NewSimulationT2D",
				templateUrl: "partials/t2d/simulation-new.html?v=1.5.3"
			}).
			when("/ukpdsom2/home", {
				controller: "HomeUKPDSOM2",
				templateUrl: "partials/ukpdsom2/home.html"
			}).
			when("/ukpdsom2/cohorts", {
				controller: "CohortsUKPDSOM2",
				templateUrl: "partials/ukpdsom2/cohorts.html?v=1.2.1"
			}).
			when("/ukpdsom2/cohort/:id", {
				controller: "EditCohortUKPDSOM2",
				templateUrl: "partials/ukpdsom2/cohort-new.html"
			}).
			when("/ukpdsom2/treatments", {
				controller: "TreatmentsUKPDSOM2",
				templateUrl: "partials/ukpdsom2/treatments.html?v=1.2.1"
			}).
			when("/ukpdsom2/treatment/:id", {
				controller: "EditTreatmentUKPDSOM2",
				templateUrl: "partials/ukpdsom2/treatment-new.html?v=1.0.3"
			}).
			when("/ukpdsom2/costs", {
				controller: "CostsUKPDSOM2",
				templateUrl: "partials/ukpdsom2/costs.html"
			}).
			when("/ukpdsom2/cost/:id", {
				controller: "EditCostUKPDSOM2",
				templateUrl: "partials/ukpdsom2/cost-new.html"
			}).
			when("/ukpdsom2/utilities", {
				controller: "UtilitiesUKPDSOM2",
				templateUrl: "partials/ukpdsom2/utilities.html"
			}).
			when("/ukpdsom2/utility/:id", {
				controller: "EditUtilityUKPDSOM2",
				templateUrl: "partials/ukpdsom2/utility-new.html"
			}).
			when("/ukpdsom2/countries", {
				controller: "CountriesUKPDSOM2",
				templateUrl: "partials/ukpdsom2/countries.html"
			}).
			when("/ukpdsom2/country/:id", {
				controller: "EditCountryUKPDSOM2",
				templateUrl: "partials/ukpdsom2/country-new.html"
			}).
			when("/ukpdsom2/simulations", {
				controller: "SimulationsUKPDSOM2",
				templateUrl: "partials/ukpdsom2/simulations.html"
			}).
			when("/ukpdsom2/simulation/:id", {
				controller: "SimulationUKPDSOM2",
				templateUrl: "partials/ukpdsom2/simulation.html"
			}).
			when("/ukpdsom2/simulations/new", {
				controller: "NewSimulationUKPDSOM2",
				templateUrl: "partials/ukpdsom2/simulation-new.html"
			}).
			when("/ukpdsom2/simulations/new/:id", {
				controller: "NewSimulationUKPDSOM2",
				templateUrl: "partials/ukpdsom2/simulation-new.html"
			}).
		  when("/admin/share/documents", {
				controller: "ShareDocumentsController",
				templateUrl: "partials/admin/admin-gate.html"
		  }).
			when("/admin/users", {
				controller: "AdminUsersController",
				templateUrl: "partials/admin/admin-users.html"
			}).
			otherwise({
				redirectTo:"/home"
			})
	}]
)